import state from './moduleLeituraState'
import mutations from './moduleLeituraMutations'
import actions from './moduleLeituraActions'
import getters from './moduleLeituraGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
